export function createRandomResults(
  questions: {
    answer: string;
    correct: boolean;
  }[],
): number[] {
  const results: number[] = [];
  const totalCorrectSeed = Math.random() * 20.0;
  const totalCorrect = Math.floor(totalCorrectSeed + 50);
  let totalRemaining = 100 - totalCorrect;

  for (let i = 0; i < questions.length; i++) {
    if (questions[i].correct) {
      results.push(totalCorrect);
    } else if (
      i < questions.length - 1 &&
      !(i === questions.length - 2 && questions[i + 1]?.correct)
    ) {
      const random = Math.floor(Math.random() * 1.0 * totalRemaining);
      results.push(random);
      totalRemaining -= random;
    } else {
      results.push(totalRemaining);
    }
  }

  return results;
}
